import type { StaffServicesSummary } from "@/types/staff/api-types/staff-services-summary-types";

import { CardSection, DataCard } from "./data-card";
import { useIntl } from "react-intl";
import { durationFromMinutes } from "@/lib/utils";

export function PriceListCard({ stylists }: { stylists: StaffServicesSummary[] }) {
  const intl = useIntl();
  const count = stylists.length === 1 ? "1 stylist" : `${stylists.length} stylists`;
  return (
    <DataCard summary={`Services and prices · ${count}`}>
      {stylists.map((stylist) => (
        <CardSection key={stylist.staff_id} title={stylist.staff_name}>
          {stylist.services.map((service) => (
            <p key={service.service_id}>
              {service.service_name}
              {service.duration_minutes != null &&
                ` · ${intl.formatDuration(durationFromMinutes(service.duration_minutes), { format: "short" })}`}
              {service.price != null && ` · ${intl.formatNumber(service.price, { format: "money" })}`}
            </p>
          ))}
        </CardSection>
      ))}
    </DataCard>
  );
}
